import { cn } from '../utils';

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  text?: string;
  color?: string;
}

/**
 * Without a `color`, the pill falls back to a background class, so a `bg-*`
 * class passed in `className` can replace it.
 */
export const Pill = ({ text, className, color, ...props }: PillProps) => (
  <span
    className={cn(
      !color && 'bg-neutral-soft',
      className,
      'text-primary inline-block rounded-full px-2.5 py-1 text-xs leading-4.5 font-medium capitalize'
    )}
    {...(color && { style: { backgroundColor: color } })}
    {...props}
  >
    {text}
  </span>
);
